import { atom } from 'jotai';
import { UserBanStatus } from '../types/UserBanStatus';

export const messageIdToDeleteAtom = atom<string>('');
export const userIdToBanMessageAtom = atom<string>('');
export const userBanForFirstTimeAtom = atom<UserBanStatus>(UserBanStatus.None);
